import doc                  from 'decorators/doc';
import SalesPrivateApiModel from 'modelx/models/abstracts/SalesPrivateApiModel';

@doc.path('/contract_iteration_summaries/{?id}/calculate_projected')
export default class ContractIterationSummaryCalculateProjectedModel extends SalesPrivateApiModel {}